import { lazy } from 'react';
import {
  checkIsGuardValidation,
  checkSuperAdminValidation,
} from '../../utility/validators/role-validtion';

const GuestsRoutes = [
  {
    path: '/all-guests',
    component: lazy(() => import('../../views/pages/GuardAllGuests')),
    profileFunctionValidation: (profile) =>
      checkIsGuardValidation(profile) || checkSuperAdminValidation(profile),
    meta: {
      publicRoute: true,
      guardRoute: true,
    },
  },
  {
    path: '/guests',
    component: lazy(() => import('../../views/pages/Guests')),
  },
];

export default GuestsRoutes;
